export default {
  badge: 'Teste',
  badge_title: 'Restaurante de teste',
  notice: 'Este é um restaurante de teste. Os pedidos feitos aqui são apenas para fins de teste.',
};
